import { useOrganicCellRenderers } from "./cellRenderersHook";
import { useOrganicClientOverviewData } from "./useOrganicClientOverviewData";
import { createOrganicVacanciesTableDataHook } from "./useOrganicVacanciesTableData";

import { registerSchemaHooks } from "@/features/integrations/shared/renderer/hooks/schemaRegistry";

/**
 * Register organic module hooks with the central module registry.
 * Imported as a side-effect from the organic client detail page.
 */
registerSchemaHooks("organic", {
  getIntegrationDataHook: () => useOrganicClientOverviewData,
  getTableDataHook: (integrationName, clientId) =>
    clientId ? createOrganicVacanciesTableDataHook(integrationName) : undefined,
  getCellRenderersHook: () => useOrganicCellRenderers,
});
